export function parseDateSafe(value) {
    if (!value) return null;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
}

export function minuteBucket(date) {
    if (!date) return null;
    return Math.floor(date.getTime() / 60000);
}

export function groupItemsByMinute(items, getTimestamp) {
    const groupsMap = new Map();
    items.forEach((it) => {
        const ts = getTimestamp ? getTimestamp(it) : new Date();
        const bucket = minuteBucket(ts);
        const key = bucket !== null ? bucket : `nogroup-${it.name}`;
        if (!groupsMap.has(key)) {
            groupsMap.set(key, { key, time: ts, items: [] });
        }
        const group = groupsMap.get(key);
        if (!group.time || (ts && ts < group.time)) {
            group.time = ts;
        }
        group.items.push(it);
    });
    const arr = Array.from(groupsMap.values());
    arr.sort((a, b) => {
        if (!a.time && !b.time) return 0;
        if (!a.time) return 1;
        if (!b.time) return -1;
        return a.time.getTime() - b.time.getTime();
    });
    return arr;
}


